export enum CareerStatus {
  ACTIVELY_LOOKING = 'Actively Looking',
  OPEN_TO_OPPORTUNITIES = 'Open to Opportunities',
  NOT_AVAILABLE = 'Not Available',
}

export const PROFILE_SECTION_IDS = {
  PERSONAL: 'personal',
  ACCOUNT: 'account',
  NOTIFICATIONS: 'notifications',
  PRIVACY: 'privacy',
  CANDIDATE: 'candidate',
} as const;

export const PROFILE_STORAGE_KEYS = {
  FIRST_NAME: 'firstname',
  LAST_NAME: 'lastname',
  EMAIL: 'email',
  PROFILE_PIC: 'profilePic',
  PHONE: 'phone',
  JOB_TITLE: 'jobTitle',
  JOB_TITLE_ID: 'jobTitleId',
  BIO: 'bio',
  PROFILE_PIC_STATUS: 'profilePicStatus',
  JOB_STATUS: 'jobStatus',
  CLASS: 'cls',
  ROLE: 'role',
} as const;

export const DEFAULT_CAREER_STATUS: CareerStatus = CareerStatus.NOT_AVAILABLE;

/**
 * Maps career status to MUI `Chip` palette colors (same convention as the
 * `/mui-preview` lab data table: success / warning / default).
 */
export const CAREER_STATUS_COLOR_MAP: Record<CareerStatus, 'success' | 'info' | 'default'> = {
  [CareerStatus.ACTIVELY_LOOKING]: 'success',
  [CareerStatus.OPEN_TO_OPPORTUNITIES]: 'info',
  [CareerStatus.NOT_AVAILABLE]: 'default',
};

export const LIVE_CAMERA_MAX_BYTES = 10 * 1024 * 1024;

export const LIVE_CAMERA_FILE_NAME_PREFIX = 'profile-pic';
